import { NgStyle } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  EventEmitter,
  inject,
  input,
  OnInit,
  Output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { marker as extractTranslation } from '@colsen1991/ngx-translate-extract-marker';
import { TranslateModule } from '@ngx-translate/core';
import { TreeviewNodeComponent } from './treeview-node.component';
import { TreeviewService } from './treeview.service';
import { NkTreeviewNode } from './treeview.utils';

@Component({
  selector: 'nk-treeview',
  imports: [FormsModule, TranslateModule, NgStyle, TreeviewNodeComponent],
  templateUrl: './treeview.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class TreeviewComponent<T> implements OnInit {
  public nodes = input<NkTreeviewNode<T>[]>([]);
  public placeholderText = input<string>(extractTranslation('treeview.filter_placeholder'));
  public noDataText = input<string>(extractTranslation('treeview.no_data'));
  public maxHeightStyle = input<string | undefined>(undefined);
  @Output() public selectionChange = new EventEmitter<NkTreeviewNode<T>[]>();
  @Output() public allNodesCheckedChange = new EventEmitter<boolean>();
  public filterText = '';
  public treeNodes = computed(() => this._treeviewService.nodes());
  private _selectedNodes = computed(() => this._treeviewService.selectedNodes());
  private _treeviewService = inject<TreeviewService<T>>(TreeviewService);

  constructor() {
    effect(() => {
      const selectedNodes = this._selectedNodes();
      this.selectionChange.emit(selectedNodes);
    });
  }

  public ngOnInit(): void {
    this._treeviewService.initializeTree(this.nodes());
  }

  public onFilterChange(): void {
    if (!this.filterText.trim()) {
      this._treeviewService.collapseAllOnEmptySearch();
    } else {
      this._treeviewService.filterNodes((item) => item.title.toLowerCase().includes(this.filterText.toLowerCase()));
    }
  }
}
